import { render, staticRenderFns } from "./ChatSettingBasic.vue?vue&type=template&id=bb5b0040&"
import script from "./ChatSettingBasic.vue?vue&type=script&lang=js&"
export * from "./ChatSettingBasic.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettingBasic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports